import { render, staticRenderFns } from "./AccountRouter.vue?vue&type=template&id=363f4838&scoped=true"
import script from "./AccountRouter.vue?vue&type=script&lang=js"
export * from "./AccountRouter.vue?vue&type=script&lang=js"
import style0 from "./AccountRouter.vue?vue&type=style&index=0&id=363f4838&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "363f4838",
  null
  
)

export default component.exports